<template>
  <svg width="20"
       height="20"
       viewBox="0 0 16 16"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M0 15.2969L7.29688 8L0 0.703125L0.703125 0L8 7.29688L15.2969 0L16 0.703125L8.70312 8L16 15.2969L15.2969 16L8 8.70312L0.703125 16L0 15.2969Z"
          fill="white" />
  </svg>
</template>
